<template>
  <div>
    <!-- <h1>Privacy Policy</h1> -->
    <div class="language-buttons">
      <button @click="changeLanguage('th')">ไทย</button>
      <button @click="changeLanguage('en')">English</button>
    </div>
    
    <hr>

    <div class="iframe-container">
      
      <iframe id="th-frame" class="contentFrame" 
          v-show="currentLang === 'th'"
          :src="urls.th" 
          title="Privacy Policy Thai">
          เนื้อหาเบราว์เซอร์ของคุณไม่รองรับ iframe.
      </iframe>

      <iframe id="en-frame" class="contentFrame" 
          v-show="currentLang === 'en'"
          :src="urls.en" 
          title="Privacy Policy English">
          เนื้อหาเบราว์เซอร์ของคุณไม่รองรับ iframe.
      </iframe>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamsComponent', // ควรตั้งชื่อ Component ตามความเหมาะสม
  data() {
    return {
      // 1. ตัวแปรสถานะที่ควบคุมภาษาปัจจุบัน (ค่าเริ่มต้นคือไทย)
      currentLang: 'th', 
      
      // 2. URL ที่ใช้โหลดใน Iframe
      urls: {
        'th': 'https://vljp.me/pdpa-privacy?type=th',
        'en': 'https://vljp.me/pdpa-privacy?type=en'
      }
    };
  },
  methods: {
    /**
     * Method สำหรับเปลี่ยนภาษา
     * @param {string} lang - 'th' หรือ 'en'
     */
    changeLanguage(lang) {
      // เมื่อเปลี่ยนค่า currentLang, Vue จะทำการอัปเดต v-show โดยอัตโนมัติ
      this.currentLang = lang;
      console.log('Vue Component: เปลี่ยนภาษาเป็น ' + lang);
    }
  }
};
</script>

<style scoped>
/* ส่วน CSS สำหรับ Component นี้ */

.iframe-container {
    width: 100%;
    height: 600px;
    border: 1px solid #ccc;
    /* margin-top: 20px; */
    position: relative;
}
.contentFrame {
    width: 100%;
    height: 100%;
    border: none;
    position: absolute;
    top: 0;
    left: 0;
}
.language-buttons button {
    padding: 10px 15px;
    margin-right: 10px;
    cursor: pointer;
}
/* ไม่จำเป็นต้องใช้ #th-frame { display: block; } เพราะ Vue จัดการผ่าน v-show แล้ว */
</style>